<template>
  <div style="background:#fff;height:100%">
    <div style="height:18px"></div>
    <div class="card-list">
      <div class="card-li">
        <div class="card-li-title">持卡人</div>
        <input type="text" placeholder="请输入持卡人姓名" v-model="data.name" />
      </div>
      <div class="card-li">
        <div class="card-li-title">银行卡号</div>
        <input
          type="number"
          placeholder="请输入银行卡号"
          v-model="data.card_num"
        />
      </div>
      <div class="card-li">
        <div class="card-li-title">开户行</div>
        <input
          type="text"
          placeholder="请输入开户行"
          v-model="data.bank_deposit"
        />
      </div>
      <div class="card-li">
        <div class="card-li-title">开户行城市</div>
        <input
          type="text"
          placeholder="请输入开户行城市"
          v-model="data.bank_city"
        />
      </div>
    </div>
    <button class="save" @click="save">保存</button>
  </div>
</template>
<script>
import { bankCard, saveCard } from "../api/user.js";
export default {
  name: "cardInform",
  data() {
    return {
      data: {
        name: "",
        card_num: "",
        bank_deposit: "",
        bank_city: ""
      }
    };
  },
  methods: {
    inform() {
      bankCard().then(res => {
        this.data.name = res.data.data.name;
        this.data.card_num = res.data.data.card_num;
        this.data.bank_deposit = res.data.data.bank_deposit;
        this.data.bank_city = res.data.data.bank_city;
      });
    },
    /**保存或更新 */
    save() {
      let data = this.data,
        _this = this;
      if (data.name == "") {
        _this.$dialog.toast({ mes: "持卡人姓名不能为空" });
        return;
      }
      if (data.card_num == "") {
        _this.$dialog.toast({ mes: "银行卡号不能为空" });
        return;
      }
      if (data.bank_deposit == "") {
        _this.$dialog.toast({ mes: "开户行不能为空" });
        return;
      }
      if (data.bank_city == "") {
        _this.$dialog.toast({ mes: "开户行城市不能为空" });
        return;
      }

      saveCard(data).then(res => {
        _this.$dialog.toast({ mes: res.msg });
        setTimeout(() => {
          window.history.go(-1);
        }, 1500);
      });
    }
  },
  mounted() {
    this.inform();
  }
};
</script>
<style scoped>
.card-list {
  height: 378px;
  background: #ffffff;
  border-radius: 6px;
  margin: 0 13px;
  border-radius: 5px;
  box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
}
.card-list .card-li {
  display: flex;
  align-items: center;
  padding-top: 33px;
}
.card-list .card-li .card-li-title {
  width: 98px;
  text-align: center;
  color: #333;
  font-size: 15px;
}
.card-list .card-li input {
  width: 5rem;
  height: 44px;
  background: rgba(237, 237, 237, 0.37);
  border-radius: 4px;
  color: #333;
  font-size: 14px;
  margin-right: 12px;
  padding-left: 15px;
}
.card-list .card-li input ::placeholder {
  color: #999999;
}
.save {
  width: 6.5rem;
  height: 50px;
  background: #d01112;
  border-radius: 100px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
  line-height: 50px;
  color: #ffffff;
  font-size: 15px;
  text-align: center;
  margin: -25px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 600;
}
</style>
